exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".icon{width:1rem;height:1rem;display:flex;align-items:center;justify-content:center}.icon svg{stroke-width:2px;fill:#fff;stroke:#fff;width:100%;height:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-54025196!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Icon.vue
// module id = 271
// module chunks = 0